module.exports = __webpack_public_path__ + "img/beer_id-17.c98cdf3c.png";